export enum ProjectOrTaskType {
  Project = 'project',
  Task = 'task',
}
